var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05952,0,0,1,-0.428028,-0.328553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.825,2.077C4.825,1.501 4.384,1.033 3.84,1.033L1.868,1.033C1.324,1.033 0.883,1.501 0.883,2.077L0.883,33.829C0.883,34.406 1.324,34.874 1.868,34.874L3.84,34.874C4.384,34.874 4.825,34.406 4.825,33.829L4.825,2.077Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04403,0,0,0.857143,-0.817881,0.704042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.578,1.232C18.578,0.552 18.124,0 17.566,0L4.663,0C4.105,0 3.652,0.552 3.652,1.232L3.652,3.696C3.652,4.376 4.105,4.928 4.663,4.928L17.566,4.928C18.124,4.928 18.578,4.376 18.578,3.696L18.578,1.232Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04403,0,0,0.857143,-0.395456,30.3207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.578,1.232C18.578,0.552 18.124,0 17.566,0L4.663,0C4.105,0 3.652,0.552 3.652,1.232L3.652,3.696C3.652,4.376 4.105,4.928 4.663,4.928L17.566,4.928C18.124,4.928 18.578,4.376 18.578,3.696L18.578,1.232Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.34591,0,0,0.857143,10.8932,16.3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.578,1.232C18.578,0.552 18.226,0 17.793,0L4.437,0C4.003,0 3.652,0.552 3.652,1.232L3.652,3.696C3.652,4.376 4.003,4.928 4.437,4.928L17.793,4.928C18.226,4.928 18.578,4.376 18.578,3.696L18.578,1.232Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.734373,-0.821351,0.638979,0.571314,20.1238,31.3154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.578,1.232C18.578,0.552 18.148,0 17.619,0L4.61,0C4.081,0 3.652,0.552 3.652,1.232L3.652,3.696C3.652,4.376 4.081,4.928 4.61,4.928L17.619,4.928C18.148,4.928 18.578,4.376 18.578,3.696L18.578,1.232Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.740583,0.828296,0.638979,-0.571314,20.5364,6.02613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.578,1.232C18.578,0.552 18.152,0 17.627,0L4.602,0C4.078,0 3.652,0.552 3.652,1.232L3.652,3.696C3.652,4.376 4.078,4.928 4.602,4.928L17.627,4.928C18.152,4.928 18.578,4.376 18.578,3.696L18.578,1.232Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.7dc8032ac1e80a1dc57745387eb351a1.svg";
export { ForwardRef as ReactComponent };